import { ArrowDownwardOutlined, ArrowUpwardOutlined, CloseOutlined, FilterList, History, LocalFireDepartmentOutlined } from '@mui/icons-material'
import { Box, Button, Card, ClickAwayListener, IconButton, Paper, Popover, Popper, Typography, useTheme } from '@mui/material'
import CustomSearchBar from '../common/CustomSearchBar'
import { useSearchParams } from 'react-router-dom'
import { Icons } from '../../utils/utilities'
import React, { useState } from 'react'

const sortOptions = [
    { icon: <LocalFireDepartmentOutlined fontSize="small" />, label: "Latest first", value: "latest" },
    { icon: <History fontSize="small" />, label: "Oldest first", value: "oldest" },
    { icon: <ArrowUpwardOutlined fontSize="small" />, label: "A-Z", value: "atoz" },
    { icon: <ArrowDownwardOutlined fontSize="small" />, label: "Z-A", value: "ztoa" },
]

const DiscussionForumFilterButton = () => {

    const [searchParams, setSearchParams] = useSearchParams( { sort: 'latest', category: "", searchText: "" } )
    const searchText = searchParams.get( 'searchText' )
    const categories = searchParams.getAll( 'category' )
    const sort = searchParams.get( 'sort' )

    const [searchOptionsAnchorEl, setSearchOptionsAnchorEl] = useState( null )
    const [sortOptionsAnchorEl, setSortOptionsAnchorEl] = useState( null )
    const [searchInputValue, setSearchInputValue] = useState( searchText )

    const { palette, border } = useTheme()

    const setSearchParamValue = ( key, val ) => {
        setSearchParams( prev => {
            prev.set( key, val )
            return prev
        }, { replace: true } )
    }

    const setSearchToFilter = ( type, value ) => {
        if ( type === 'cat' ) {
            const val = value?.trim()
            if ( val && val.length > 0 ) {

                setSearchParams( prev => {
                    const newParams = new URLSearchParams( prev )
                    const newCatgoriesList = new Set( [...categories, val] )
                    newParams.delete( 'category' )
                    Array.from( newCatgoriesList ).forEach( cat => {
                        newParams.append( 'category', cat )
                    } )
                    return newParams
                } )

            }
        } else {
            if ( searchInputValue.trim().length > 0 ) {
                setSearchParamValue( 'searchText', searchInputValue )
            }
        }
        setSearchInputValue( "" )
        setSearchOptionsAnchorEl( null )
    }

    const handleKeyDown = ( event ) => {
        if ( event.key === 'Enter' ) {
            event.preventDefault()
        }
    }

    const handleSortOptionChange = async ( val ) => {
        setSearchParamValue( 'sort', val )
        setSortOptionsAnchorEl( null )
    }

    const handleSearchValueChange = event => {
        const val = ( event?.target?.value || "" ).trim()
        setSearchInputValue( val )
        if ( val ) {
            setSearchOptionsAnchorEl( event.currentTarget )
        } else {
            setSearchOptionsAnchorEl( null )
        }
    }

    return (
        <Box flexGrow={1}>
            <Box width="100%" display="flex" gap="10px">
                {/* <Button variant='outlined' sx={{ borderRadius: "20px" }} startIcon={Icons.default.FilterAlt} onClick={( e ) => setFilterOptionsDialogAnchorEl( e.currentTarget )} size="small" color='contrast'>
                    Filter Discussions
                </Button> */}
                <Button endIcon={Icons.default.KeyboardArrowDownIcon} variant='outlined' startIcon={sort ? sortOptions.find( srt => srt.value === sort ).icon : Icons.default.Sort} onClick={( e ) => setSortOptionsAnchorEl( e.currentTarget )} size="small" color={sort ? 'primary' : 'contrast'}>
                    {sort ? sortOptions.find( srt => srt.value === sort ).label : "Sort"}
                </Button>
                <CustomSearchBar onKeyDown={handleKeyDown} style={{ flexGrow: 1 }} buttonIcon={Icons.small.SearchIcon} icon={""} value={searchInputValue} onChange={handleSearchValueChange} type="text" placeholder="Search by Title, Subject or Category" />
            </Box>

            <Popper onClose={() => setSearchOptionsAnchorEl( null )} open={Boolean( searchOptionsAnchorEl ) && searchInputValue?.trim().length > 0} placement='bottom-start' anchorEl={searchOptionsAnchorEl}>
                <ClickAwayListener onClickAway={() => setSearchOptionsAnchorEl( null )} >
                    <Box border={border[1]} component={Paper} borderRadius="10px" overflow="clip" marginTop="5px" >
                        <Box
                            onClick={( event ) => setSearchToFilter( 'cat', searchInputValue )}
                            display="flex"
                            sx={{
                                cursor: "pointer",
                                "&:hover": {
                                    background: palette.rowHover
                                }
                            }} gap="10px" padding="5px 10px" alignItems="center">
                            {Icons.default.Category}
                            <Typography variant="subtitle2"> <Typography component="em">Category: </Typography>{searchInputValue} </Typography>
                        </Box>
                        <Box
                            onClick={( event ) => setSearchToFilter( 'search', searchInputValue )}
                            display="flex"
                            sx={{
                                cursor: "pointer",
                                "&:hover": {
                                    background: palette.rowHover
                                }
                            }} gap="10px" padding="5px 10px" alignItems="center">
                            {Icons.default.Text}
                            <Typography variant="subtitle2"> <Typography component="em">Title: </Typography>{searchInputValue} </Typography>
                        </Box>
                    </Box>
                </ClickAwayListener>
            </Popper>

            <Popper onClose={() => setSortOptionsAnchorEl( null )} open={Boolean( sortOptionsAnchorEl )} placement='bottom-start' anchorEl={sortOptionsAnchorEl}>
                <ClickAwayListener onClickAway={() => setSortOptionsAnchorEl( null )} >
                    <Box border={border[1]} component={Paper} borderRadius="10px" overflow="clip" marginTop="5px" >
                        {sortOptions.map( sortOption => (
                            <Box
                                onClick={() => handleSortOptionChange( sortOption.value )}
                                display="flex"
                                sx={{
                                    background: sort === sortOption.value ? `${palette.primary.light}bb` : palette.background.paper,
                                    color: sort === sortOption.value ? palette.primary.contrastText : palette.common.font,
                                    cursor: "pointer",
                                    "&:hover": {
                                        background: sort !== sortOption.value && palette.rowHover
                                    }
                                }} gap="10px" padding="5px 10px" key={sortOption.label} alignItems="center">
                                {sortOption.icon}
                                <Typography variant="subtitle2">{sortOption.label}</Typography>
                            </Box>
                        ) )}
                    </Box>
                </ClickAwayListener>
            </Popper>
        </Box >
    )
}

export default DiscussionForumFilterButton
